/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/~/lodash/_freeGlobal.js
// module id = 1143
// module chunks = 4